import "./common.js"
import "@styles/common.less"
import Vue from "vue"
import documentSignature from "@page-components/wesign/document-signature.vue"


import NetworkeWatcher from "@commons/check-networkstatus.js"
import axios from "@interfaces/axios.js"
axios.defaults.withCredentials = true

//element-ui 引入
import {
    Message,
    Button,
    Card
} from "element-ui"
Vue.use(Button)
Vue.use(Card)
Vue.prototype.$message = Message

//网站监测
let networkWatcher = new NetworkeWatcher({
    onOffline(){
        Message({
            showClose: true,
            message: "您的网络存在异常，请检查网络是否正常连接",
            type: "error",
            duration: 5000,
            onClose: () => {
                networkWatcher.onLine = true
            }
        })
    },
})

axios.interceptors.response.use(function (config) {
    return config
}, function (error) {
    if (error.message === "Network Error"){
        networkWatcher.checkNetwork()
    }
    return Promise.reject(error)
})

new Vue({
    el: "#app",
    template: "<documentSignature />",
    components: {
        documentSignature
    }
})